(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.formFilter = {
    attach: function (context, settings) {
      once('formFilter', '.filters', context).forEach(function (block) {

        $('#edit-name').attr('placeholder', $('label[for="edit-name"]').html())
        $('#edit-search').attr('placeholder', $('label[for="edit-search"]').html())
        $('#edit-combine').attr('placeholder', $('label[for="edit-combine"]').html())

        var maxLength = 40;
        $('.filters select option').text(function(i, text) {
          $(this).attr('title', text);
          if (text.length > maxLength) {
            return text.substr(0, maxLength) + '...';
          }
        });
        $('.filters select optgroup').attr('title', function(e, val) {
          return $(this).attr('label');
        });
        $('.filters select optgroup').attr('label', function(e, val) {
          if (val.length > maxLength) {
            return val.substr(0, maxLength) + '...';
          }
        });

        $(".filters .js-form-type-select").each(function(){
          if(!$(this).is('.form-item-sector')) {
            let label = $(this).find('label').hide();
            $(this).find('select').prepend('<option value="all" disabled="disabled">' + label.html() + '</option>');
          }
        });


        /*$('.filters').each(function(){
          let optionsNbr = $(this.childElementCount);
          if(optionsNbr[0] > 8) {
            $(this).addClass('js-manyOpt')
          } else {
            $(this).addClass('js-lessOpt')
          }
        })*/
        /*$('.filters form select').niceSelect();*/
      });
      /*$(once('formFilter', '.path-actualites #block-mainpagecontent form', context)).each(function () {
        $('#block-mainpagecontent form select').niceSelect();
      });*/
    }
  }
})(jQuery, Drupal, once, drupalSettings);
